import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../../store/configureStore';
import {
    DrivePermissionsErrorModalHOC
} from '../dialogs/drivePermissionsErrorModal/hocs/DrivePermissionsErrorModalHOC/DrivePermissionsErrorModalHOC';

export class DrivePermissionsErrorModal {
    el: HTMLElement;
    error: string;

    constructor (error: string) {
        if (this.el) this.remove();
        this.error = error;
        this.el = document.createElement('div');
        this.el.className = 'drive-permissions-error-placeholder';
        document.body.append(this.el);
        this.render();
    }

    render () {
        ReactDOM.render(
            <Provider store={store}>
                <DrivePermissionsErrorModalHOC error={this.error} />
            </Provider>
            , this.el);
    }

    remove () {
        if (!this.el) return;

        ReactDOM.unmountComponentAtNode(this.el);
        this.el.remove();
        this.el = null;
    }
}
